import { useActivityLink } from "PFApp/hooks";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useActivity } from "PFCore/hooks/queries/activity";
import NoProfilesIllustration from "PFTheme/graphics/illustrations/illustration-no-profiles.svg";
import { Activity } from "PFTypes";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";

import css from "./no_matches_placeholder.module.scss";

type NoMatchesPlaceholderProps = {
  activity: Activity | undefined;
  renderNoMatchesActionAllResourcesFallback?: (onAllResourcesClick: VoidFunction) => React.ReactNode;
  onAllResourcesFallbackClick?: VoidFunction;
};

export const NoMatchesPlaceholder = ({
  activity,
  renderNoMatchesActionAllResourcesFallback,
  onAllResourcesFallbackClick
}: NoMatchesPlaceholderProps) => {
  const { t } = useTranslation(["core", "activities"]);

  const { data: parentActivity } = useActivity(activity?.parent_activity_id ?? -1, {
    enabled: !!activity?.parent_activity_id
  });

  const activityLink = useActivityLink({ activity, parentActivity });
  const isCompleted = activity?.state === "complete";

  return (
    <Stack center gap="spacingLg" className={css.root}>
      <NoProfilesIllustration className={css.icon} />
      <div className={css.messageContainer}>
        <Typography variant="h5">{t("activities:resourceTableToggle.matches.noMatches")}</Typography>
        <Typography variant="h5" className={css.actions}>
          {activityLink && (
            <>
              <Trans
                i18nKey={
                  isCompleted
                    ? "activities:resourceTableToggle.matches.closedRoleAction"
                    : "activities:resourceTableToggle.matches.noMatchesAction"
                }
                t={t}
                values={{ activityName: activity?.name ?? t("core:activity") }}
                components={[<Link key="activityLink" to={activityLink} />]}
              />
              {!!onAllResourcesFallbackClick &&
                renderNoMatchesActionAllResourcesFallback?.(onAllResourcesFallbackClick)}
            </>
          )}
        </Typography>
      </div>
    </Stack>
  );
};
